import { render, staticRenderFns } from "./ProductTypeWizard.vue?vue&type=template&id=392a300a&"
import script from "./ProductTypeWizard.vue?vue&type=script&lang=js&"
export * from "./ProductTypeWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports